export enum EntityProfileType {
  PROFESSIONAL = 'profissional',
  PARTNER = 'parceiro',
  LABORATORY = 'laboratorio',
}
